module.exports = __webpack_public_path__ + "static/St-mock-068135f6b7b7cd5e19ad56af6bc419f4.png";